import React from "react";

const Text = ({ text }) => {
    return <p className="text">{text}</p>;
};

export default Text;
